import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { getToken, refreshToken } from '@/services/token';

export const HTTPAuth = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
});

export const HTTPNoAuth = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
});

HTTPAuth.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    config.headers['Authorization'] = `Bearer ${getToken()}`;
    return config;
  },

  error => {
    return Promise.reject(error);
  }
);

HTTPAuth.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },

  error => {
    if (error.response && error.response.status === 401) {
      refreshToken();
    }

    if (error.response && error.response.status === 403) {
      throw new Error('You do not have permission to perform this action.');
    }

    return Promise.reject(error);
  }
);
